import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "content-left self-center top-logo-col" };
const _hoisted_2 = { class: "content-left self-center top-logo-col" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "self-center footer-subscription-col" };
const _hoisted_5 = { class: "row justify-center q-py-sm" };
const _hoisted_6 = { class: "col-12 text-caption text-weight-bold q-pb-xs" };
const _hoisted_7 = { class: "col-12" };
const _hoisted_8 = { class: "row" };
const _hoisted_9 = { class: "col-break-lg-4-12 pt-md-lt-lg" };
const _hoisted_10 = { class: "text-weight-bold text-body1" };
const _hoisted_11 = { class: "row q-pt-md" };
const _hoisted_12 = { class: "links cursor-pointer" };
const _hoisted_13 = ["href"];
const _hoisted_14 = { class: "links cursor-pointer" };
const _hoisted_15 = { class: "col-break-lg-4-12 pt-md-lt-lg" };
const _hoisted_16 = { class: "text-weight-bold text-body1" };
const _hoisted_17 = { class: "row q-pt-md" };
const _hoisted_18 = { class: "links cursor-pointer" };
const _hoisted_19 = ["href"];
const _hoisted_20 = { class: "links cursor-pointer" };
const _hoisted_21 = { class: "col-break-lg-4-12 pt-md-lt-lg" };
const _hoisted_22 = { class: "text-weight-bold text-body1" };
const _hoisted_23 = { class: "row q-pt-md" };
const _hoisted_24 = { class: "links cursor-pointer" };
const _hoisted_25 = { class: "row q-pt-xs text-center" };
const _hoisted_26 = { class: "self-center col-12" };
const _hoisted_27 = { class: "row justify-center" };
const _hoisted_28 = {
    href: "https://blog.getspaces.com",
    target: "_blank",
    rel: "noopener"
};
const _hoisted_29 = { class: "links cursor-pointer" };
const _hoisted_30 = { class: "links cursor-pointer" };
const _hoisted_31 = { class: "links cursor-pointer" };
const _hoisted_32 = { class: "links cursor-pointer" };
const _hoisted_33 = { class: "row justify-center q-py-md" };
const _hoisted_34 = {
    href: "https://www.facebook.com/GetSpacesSG",
    target: "_blank",
    rel: "noopener noreferrer external",
    "aria-label": "Find GetSpaces in Facebook"
};
const _hoisted_35 = {
    href: "https://www.instagram.com/getspaces.sg/",
    target: "_blank",
    rel: "noopener noreferrer external",
    "aria-label": "Find GetSpaces in Instagram"
};
const _hoisted_36 = {
    href: "https://www.linkedin.com/company/bookgetspaces/",
    target: "_blank",
    rel: "noopener noreferrer external",
    "aria-label": "Find GetSpaces in LinkedIn"
};
const _hoisted_37 = { class: "col-12" };
const _hoisted_38 = { class: "text-caption" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_lazy_load = _resolveComponent("lazy-load");
    const _component_router_link = _resolveComponent("router-link");
    const _component_subscription = _resolveComponent("subscription");
    const _component_intersection = _resolveComponent("intersection");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_landing_section = _resolveComponent("landing-section");
    return (_ctx.forceShowFooter || (['desktop', 'mobile'].indexOf(_ctx.styleType) > -1 && _ctx.centralShowFooter))
        ? (_openBlock(), _createBlock(_component_landing_section, {
            key: 0,
            "no-padding": "",
            classes: {
                'bg-grey-6': true
            },
            class: "black-white-text-color",
            ref: "footerRef"
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", {
                    class: _normalizeClass(["row q-pt-md", {
                            'justify-start': _ctx.styleType === 'desktop',
                        }])
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_router_link, {
                            to: { name: 'Home' },
                            "aria-label": "Go Home"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_lazy_load, {
                                    alt: "GetSpaces logo",
                                    url: "https://dminqct125wnz.cloudfront.net/spaces/appIcons/logo_original_white",
                                    "pic-class": {
                                        'logo-footer': true
                                    },
                                    format: "png",
                                    "allow-other-formats": "",
                                    side: "",
                                    onClick: _ctx.scrollTop
                                }, null, 8, ["onClick"])
                            ]),
                            _: 1
                        }),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_lazy_load, {
                                    alt: "Google Play Icon",
                                    url: "https://dminqct125wnz.cloudfront.net/common/logos/googlePlay",
                                    "pic-class": {
                                        'new-store-icon': true
                                    },
                                    class: "q-mt-md self-center cursor-pointer q-pr-sm",
                                    format: "png",
                                    "allow-other-formats": "",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.openurl('https://play.google.com/store/apps/details?id=org.getspaces.app')))
                                }),
                                _createVNode(_component_lazy_load, {
                                    alt: "Google Play Icon",
                                    url: "https://dminqct125wnz.cloudfront.net/common/logos/appleStore",
                                    "pic-class": {
                                        'new-store-icon': true
                                    },
                                    class: "q-mt-md cursor-pointer",
                                    format: "png",
                                    "allow-other-formats": "",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.openurl('https://apps.apple.com/us/app/id1516262495')))
                                })
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_intersection, {
                            onInView: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('in-view', $event)))
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t('Subscribe text')), 1),
                                    _createElementVNode("div", _hoisted_7, [
                                        _createVNode(_component_subscription)
                                    ])
                                ])
                            ]),
                            _: 1
                        })
                    ])
                ], 2),
                _createVNode(_component_q_separator, { class: "q-my-sm footer-separator-style" }),
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.t('Flexible Rent')), 1),
                        _createElementVNode("div", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSpacesList, (value, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: "col-break-sm-6-12 pa-xs-gt-sm py-xs-lt-sm",
                                    key: `services-${index}`
                                }, [
                                    _createVNode(_component_q_card, {
                                        flat: "",
                                        class: "bg-grey-6"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_q_card_section, { class: "link-padding text-body2" }, {
                                                default: _withCtx(() => [
                                                    (!value.external)
                                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                                            key: 0,
                                                            to: { name: value.routeName, query: value.query },
                                                            target: _ctx.styleType === 'app' ? '' : '_blank'
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createElementVNode("span", _hoisted_12, _toDisplayString(value.display_name || value.title), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["to", "target"]))
                                                        : (_openBlock(), _createElementBlock("a", {
                                                            key: 1,
                                                            href: value.url,
                                                            target: "_blank",
                                                            rel: "noopener noreferrer external"
                                                        }, [
                                                            _createElementVNode("span", _hoisted_14, _toDisplayString(value.display_name || value.title), 1)
                                                        ], 8, _hoisted_13))
                                                ]),
                                                _: 2
                                            }, 1024)
                                        ]),
                                        _: 2
                                    }, 1024)
                                ]));
                            }), 128))
                        ])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.t('Rent')), 1),
                        _createElementVNode("div", _hoisted_17, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPropertyList, (value, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: "col-break-sm-6-12 pa-xs-gt-sm py-xs-lt-sm",
                                    key: `services-${index}`
                                }, [
                                    _createVNode(_component_q_card, {
                                        flat: "",
                                        class: "bg-grey-6"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_q_card_section, { class: "link-padding text-body2" }, {
                                                default: _withCtx(() => [
                                                    (!value.external)
                                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                                            key: 0,
                                                            to: { name: value.routeName, query: value.query },
                                                            target: _ctx.styleType === 'app' ? '' : '_blank'
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createElementVNode("span", _hoisted_18, _toDisplayString(value.display_name || value.title), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["to", "target"]))
                                                        : (_openBlock(), _createElementBlock("a", {
                                                            key: 1,
                                                            href: value.url,
                                                            target: "_blank",
                                                            rel: "noopener noreferrer external"
                                                        }, [
                                                            _createElementVNode("span", _hoisted_20, _toDisplayString(value.display_name || value.title), 1)
                                                        ], 8, _hoisted_19))
                                                ]),
                                                _: 2
                                            }, 1024)
                                        ]),
                                        _: 2
                                    }, 1024)
                                ]));
                            }), 128))
                        ])
                    ], 512), [
                        [_vShow, _ctx.getPropertyList.length > 0]
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.t('Terms and Policies')), 1),
                        _createElementVNode("div", _hoisted_23, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tacList, (value, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: "col-break-sm-6-12 pa-xs-gt-sm py-xs-lt-sm",
                                    key: `services-${index}`
                                }, [
                                    _createVNode(_component_q_card, {
                                        flat: "",
                                        class: "bg-grey-6"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_q_card_section, { class: "link-padding text-body2" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_router_link, {
                                                        to: { name: value.routeName, query: value.query },
                                                        target: _ctx.styleType === 'app' ? '' : '_blank'
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("span", _hoisted_24, _toDisplayString(value.display_name || value.title), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["to", "target"])
                                                ]),
                                                _: 2
                                            }, 1024)
                                        ]),
                                        _: 2
                                    }, 1024)
                                ]));
                            }), 128))
                        ])
                    ])
                ]),
                _createVNode(_component_q_separator, { class: "q-my-sm footer-separator-style" }),
                _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("a", _hoisted_28, [
                                _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.t('Blog')), 1)
                            ]),
                            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "q-px-md" }, "|", -1)),
                            _createVNode(_component_router_link, { to: { name: 'Contact Us' } }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.t('Contact')), 1)
                                ]),
                                _: 1
                            }),
                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "q-px-md" }, "|", -1)),
                            _createVNode(_component_router_link, { to: { name: 'About' } }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.t('About')), 1)
                                ]),
                                _: 1
                            }),
                            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "q-px-md" }, "|", -1)),
                            _createVNode(_component_router_link, { to: { name: 'Sitemap' } }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.t('Sitemap')), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("a", _hoisted_34, [
                                _createVNode(_component_q_btn, {
                                    flat: "",
                                    round: "",
                                    size: "16px",
                                    name: "facebook",
                                    icon: "font-custom-facebook",
                                    class: "links q-mx-lg",
                                    "aria-label": "Find GetSpaces in Facebook"
                                })
                            ]),
                            _createElementVNode("a", _hoisted_35, [
                                _createVNode(_component_q_btn, {
                                    flat: "",
                                    round: "",
                                    size: "16px",
                                    name: "instagram",
                                    icon: "font-custom-instagram",
                                    class: "links q-mx-lg",
                                    "aria-label": "Find GetSpaces in Instagram"
                                })
                            ]),
                            _createElementVNode("a", _hoisted_36, [
                                _createVNode(_component_q_btn, {
                                    flat: "",
                                    round: "",
                                    size: "16px",
                                    name: "linkedin",
                                    icon: "font-custom-linkedin",
                                    class: "links q-mx-lg",
                                    "aria-label": "Find GetSpaces in LinkedIn"
                                })
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("span", _hoisted_38, "© " + _toDisplayString(_ctx.todayYear) + " GET TECHNOLOGIES PTE. LTD. All rights reserved. Use of this site consitutes acceptance of our Terms of Use and Privacy Policy", 1)
                    ])
                ])
            ]),
            _: 1
        }, 512))
        : _createCommentVNode("", true);
}
